import { Body, Flex, styled } from '@teko/ds-desktop';
import { FacebookFilled, LinkOutlined, MessengerColored } from '@teko/ds-icon';
import { ZaloShareButton } from 'components/desktop/organisms';
import { useTenantConfig, useToast } from 'contexts';
import { t } from 'i18n';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useCookieConsentStore } from 'stores';

export const ShareButtons: React.FC<{}> = () => {
  const toast = useToast();
  const { getProcessEnv, zaloOAId, epicOmni1936 } = useTenantConfig();
  const router = useRouter();
  const [zaloShareUrl, setzaloShareUrl] = useState('');
  const isZaloCookiesConsented = useCookieConsentStore((state) =>
    state.functionalityStorage(),
  );
  const copyCurrentUrl = async (): Promise<void> => {
    if (
      typeof navigator === 'undefined' ||
      typeof window === 'undefined' ||
      !navigator ||
      !window.location?.href
    ) {
      return;
    }
    await navigator.clipboard.writeText(window.location.href);
    toast.success?.({
      title: null,
      message: t('Đã sao chép đường dẫn'),
    });
  };

  const shareFacebook = () => {
    if (typeof window === 'undefined' || !window.location?.href) return;
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        window.location.href,
      )}`,
      'new-window',
      `status = 1, width=${window.screen.width / 2}, height=${
        window.screen.height / 2
      }, top=${window.screen.height / 4}, 
      left=${window.screen.width / 4}, scrollbars=no`,
    );
  };

  const shareMessenger = () => {
    if (typeof window === 'undefined' || !window.location?.href) return;
    window.open(
      `http://www.facebook.com/dialog/send?app_id=${getProcessEnv(
        'NEXT_PUBLIC_FB_APP_ID',
      )}&link=${encodeURIComponent(
        window.location.href,
      )}&redirect_uri=${encodeURIComponent(window.location.href)}`,
      'new-window',
      `status = 1, width=${window.screen.width / 2}, height=${
        window.screen.height / 2
      }, top=${window.screen.height / 4}, 
      left=${window.screen.width / 4}, scrollbars=no`,
    );
  };

  //set zaloShareUrl
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const fullUrl = window.location.origin + router.asPath;
      setzaloShareUrl(fullUrl);
    }
  }, [router.asPath]);

  return (
    <Flex gap="s8" marginTop="s12" align="center">
      <Body level={1}>
        {t('Chia sẻ')}
        {': '}
      </Body>
      <Flex gap="s4" align="center" justify="center">
        {!!zaloShareUrl &&
          !!zaloOAId &&
          (!!epicOmni1936 ? isZaloCookiesConsented : true) && (
            <Flex height="24px" width="24px" align="center" justify="center">
              <ZaloShareButton
                url={zaloShareUrl}
                zaloOAId={zaloOAId}
                size="18"
              />
            </Flex>
          )}
        <MessengerColored
          onClick={shareMessenger}
          size="24"
          style={{ cursor: 'pointer' }}
        />
        <Flex height="24px" width="24px" align="center" justify="center">
          <FacebookFilled
            onClick={shareFacebook}
            size="20"
            style={{ cursor: 'pointer' }}
            color="#0958D9"
          />
        </Flex>
        <Flex height="24px" width="24px" align="center" justify="center">
          <LinkOutlinedWrapper
            height="16px"
            width="16px"
            onClick={copyCurrentUrl}
            align="center"
            justify="center"
          >
            <StyledLinkOutlined color="white" size="14" />
          </LinkOutlinedWrapper>
        </Flex>
      </Flex>
    </Flex>
  );
};

const StyledLinkOutlined = styled(LinkOutlined)`
  -webkit-transform: rotate(135deg);
  -moz-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
  -o-transform: rotate(135deg);
  transform: rotate(135deg);
  cursor: pointer;
`;

const LinkOutlinedWrapper = styled(Flex)`
  border-radius: 50%;
  background-color: #52c41a;
`;
